import React, { ChangeEvent, FC } from 'react';
import { Input } from '@headlessui/react';
import { Search } from 'lucide-react';

interface SearchInputProps {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  id?: string;
  autoFocus?: boolean;
}

const SearchInput: FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = 'Search...',
  className = '',
  id,
  autoFocus,
}) => {
  return (
    <div className={`relative  `}>
      <Search
        className='absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400'
        size={16}
      />
      <Input
        id={id}
        type='text'
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`${className} bg-primary-variant rounded-lg h-[38px] py-1 pl-10 pr-4 text-sm focus:outline-none focus:ring-1 focus:ring-color-accent  w-full border border-primary-subtle`}
        autoFocus={autoFocus}
      />
    </div>
  );
};

export default SearchInput;
